'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLocalLaundryService = function MdLocalLaundryService(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 33.4q4.1 0 7.1-3t2.9-7-2.9-7.1-7.1-2.9-7.1 2.9-2.9 7.1 2.9 7 7.1 3z m-8.4-26.8q-0.7 0-1.1 0.5t-0.5 1.3 0.5 1.1 1.1 0.5 1.3-0.5 0.5-1.1-0.5-1.3-1.3-0.5z m5 0q-0.7 0-1.1 0.5t-0.5 1.3 0.5 1.1 1.1 0.5 1.3-0.5 0.5-1.1-0.5-1.3-1.3-0.5z m13.4-3.2q1.4 0 2.4 0.9t1 2.3v26.8q0 1.4-1 2.3t-2.4 0.9h-20q-1.4 0-2.4-0.9t-1-2.3v-26.8q0-1.4 1-2.3t2.4-0.9h20z m-14.7 24.6l9.4-9.4q1.9 1.9 1.9 4.7t-1.9 4.7-4.7 2-4.7-2z' })
        )
    );
};

exports.default = MdLocalLaundryService;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/local-laundry-service.js
// module id = 3506
// module chunks = 168707334958949